import { render, staticRenderFns } from "./premiacoes.vue?vue&type=template&id=182ce68f"
import script from "./premiacoes.vue?vue&type=script&lang=js"
export * from "./premiacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports